<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Payment Details",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Payment Details",
            items: [
               {
                  text: "Payments",
                  href: "/payments",
               },                
               
               {
                  text: "Details",
                  active: true,
               },                     
            ],

            payment: {
               amount: 2250,
               payment_id: '',
               notes: '',
            },
            token: '',
            errors: {},

         };
      },
      mounted() {
    
      },

      methods: {
         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },     
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">

                        <router-link :to="{ name: 'doctors.payments' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                        
                     </div>
                  </div>
                  <!----- top button area ends---->                  

                  <!---- Details starts -------->
                  <div class="row">
                     <div class=" col-lg-5 col-md-5">
                        

                        <b-card header-class="bg-transparent border-light" class="border border-light">  
                           <h4 class="font-size-18 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Pending Amount Details</h4>                         
                           <b-row>

                              <b-col md="12">
                                 <h5>Doctor Name:</h5>
                                 <p>Dr. Prasad Varkey</p>

                                 <h5>Total Amount</h5>
                                 <p>Rs. 2500</p>

                                 <h5>Amount to be Paid</h5>
                                 <p>Rs. 2250</p>

                                 <h5>Commission</h5>
                                 <p>Rs. 250</p>
                              </b-col>    

                           </b-row>
                           <b-button v-b-modal.payment-modal variant="primary" class="btn-sm mt-2 mr-1">Add Payment</b-button>
                        </b-card>

                     </div>

                     <div class="col-lg-7 col-md-7">
                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           
                           <h4 class="font-size-18 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Consultations</h4>
                           
                           <b-row>

                              <b-col lg="6" class="payment-consultation">
                                 <h5>Peter John</h5>
                                 <p>10 Mar 2022, 09:10 am - 09:20 am<br>
                                    Video Consultation - Rs. 250</p>
                              </b-col>   

                              <b-col lg="6" class="payment-consultation">
                                 <h5>Peter John</h5>
                                 <p>10 Mar 2022, 09:10 am - 09:20 am<br>
                                    Video Consultation - Rs. 250</p>
                              </b-col>  

                              <b-col lg="6" class="payment-consultation">
                                 <h5>Peter John</h5>
                                 <p>10 Mar 2022, 09:10 am - 09:20 am<br>
                                    Video Consultation - Rs. 250</p>
                              </b-col>  

                              <b-col lg="6" class="payment-consultation">
                                 <h5>Peter John</h5>
                                 <p>10 Mar 2022, 09:10 am - 09:20 am<br>
                                    Video Consultation - Rs. 250</p>
                              </b-col>  

                              <b-col lg="6" class="payment-consultation">
                                 <h5>Peter John</h5>
                                 <p>10 Mar 2022, 09:10 am - 09:20 am<br>
                                    Video Consultation - Rs. 250</p>
                              </b-col>  

                              <b-col lg="6" class="payment-consultation">
                                 <h5>Peter John</h5>
                                 <p>10 Mar 2022, 09:10 am - 09:20 am<br>
                                    Video Consultation - Rs. 250</p>
                              </b-col>  

                              <b-col lg="6" class="payment-consultation">
                                 <h5>Peter John</h5>
                                 <p>10 Mar 2022, 09:10 am - 09:20 am<br>
                                    Video Consultation - Rs. 250</p>
                              </b-col>

                              <b-col lg="6" class="payment-consultation">
                                 <h5>Peter John</h5>
                                 <p>10 Mar 2022, 09:10 am - 09:20 am<br>
                                    Video Consultation - Rs. 250</p>
                              </b-col>  

                              <b-col lg="6" class="payment-consultation">
                                 <h5>Peter John</h5>
                                 <p>10 Mar 2022, 09:10 am - 09:20 am<br>
                                    Video Consultation - Rs. 250</p>
                              </b-col>  

                              <b-col lg="6" class="payment-consultation">
                                 <h5>Peter John</h5>
                                 <p>10 Mar 2022, 09:10 am - 09:20 am<br>
                                    Video Consultation - Rs. 250</p>
                              </b-col>     

                           </b-row>
                        </b-card>
                        <!-- end card -->

                      

                     </div>
                     
                  </div>
                  <!---- Details ends -------->

               </div>
            </div>
         </div>
      </div>

      <!---- modal starts ---->
                                 <b-modal ref="payment-modal" id="payment-modal" title="Payment" hide-footer>
                                    <b-form>
                                       
                                       <b-col md="12" class="form-group">
                                          <label class="control-label">Amount (in Rs)<span class="required">*</span></label>
                                          <input type="text" v-model="payment.amount" class="form-control">
                                       </b-col>  

                                       <b-col md="12" class="form-group">
                                          <label class="control-label">Payment ID<span class="required">*</span></label>
                                          <input type="text" v-model="payment.payment_id" class="form-control">
                                       </b-col>  

                                       <b-col md="12" class="form-group">
                                          <label class="control-label">Payment Image<span class="required">*</span></label>
                           
                                          <b-form-file
                                             placeholder="Choose an image or drop it here..."
                                             drop-placeholder="Drop image here..."
                                          ></b-form-file>
                                       </b-col>    

                                       <b-col md="12" class="form-group">
                                          <label class="control-label">Payment Notes<span class="required">*</span></label>
                                          <textarea class="form-control" v-model="payment.notes" rows="3"></textarea>
                                       </b-col>                       
                                        
                                       <b-col md="12">
                                          <b-button type="button" class="mr-3" variant="primary" @click="hideModal('payment-modal')">Save</b-button>
                                          <b-button class="" variant="light" @click="hideModal('payment-modal')">Close</b-button>
                                       </b-col>
                                    </b-form>
                                 </b-modal>
                                 <!---- modal ends ----->
   </Layout>
</template>
